// blog data

export const Blogs = [
    // {
    //     id:1,
    //     name:"Build Website with ReactJS, Styled-components and GSAP for Scrolling Animations",
    //     tags:["react","gsap","styled-components"],
    //     date:"13 May, 2021",
    //     imgSrc:"https://res.cloudinary.com/practicaldev/image/fetch/s--sBeV06Xc--/c_imagga_scale,f_auto,fl_progressive,h_420,q_auto,w_1000/https://dev-to-uploads.s3.amazonaws.com/uploads/articles/2yrzy75q4dzibqz6rf82.png",
    //     link:"https://dev.to/codebucks/build-website-with-reactjs-styled-components-and-gsap-for-scrolling-animations-2f10"
    // },
    // {
    //     id:2,
    //     name:"How to create React Hamburger Menu using Styled-Components",
    //     tags:["react","styled-components"],
    //     date:"5 July, 2021",
    //     imgSrc:"https://codebucks.hashnode.dev/_next/image?url=https%3A%2F%2Fcdn.hashnode.com%2Fres%2Fhashnode%2Fimage%2Fupload%2Fv1625479747640%2F7KzwP9nmj.png%3Fw%3D1600%26h%3D840%26fit%3Dcrop%26crop%3Dentropy%26auto%3Dcompress%2Cformat%26format%3Dwebp&w=1920&q=75",
    //     link:"https://codebucks.hashnode.dev/react-hamburger-menu"
    // },
    // {
    //     id:3,
    //     name:"React Loading Screen: Try these 3 cool loading screens for your app",
    //     tags:["react","react-lottie","styled-components"],
    //     date:"6 July, 2021",
    //     imgSrc:"https://codebucks.hashnode.dev/_next/image?url=https%3A%2F%2Fcdn.hashnode.com%2Fres%2Fhashnode%2Fimage%2Fupload%2Fv1625552344293%2Fegwis0UIX.png%3Fw%3D1600%26h%3D840%26fit%3Dcrop%26crop%3Dentropy%26auto%3Dcompress%2Cformat%26format%3Dwebp&w=1920&q=75",
    //     link:"https://codebucks.hashnode.dev/react-loading-screens"
    // },
    // {
    //     id:4,
    //     name:"How to build a Fabulous Todo App using React, Redux and Framer-Motion",
    //     tags:["react","redux","framer-motion"],
    //     date:"26 May, 2021",
    //     imgSrc:"https://res.cloudinary.com/practicaldev/image/fetch/s--r5oUDhhT--/c_imagga_scale,f_auto,fl_progressive,h_420,q_auto,w_1000/https://dev-to-uploads.s3.amazonaws.com/uploads/articles/036s7j5b73up7455rdth.png",
    //     link:"https://dev.to/codebucks/build-redux-react-todo-list-app-with-animations-using-framer-motion-1mp1"
    // },
    // {
    //     id:5,
    //     name:"What is Higher Order Component (HOC) in React JS?",
    //     tags:["react","reactJS","web-development"],
    //     date:"3 Feb, 2021",
    //     imgSrc:"https://codebucks.hashnode.dev/_next/image?url=https%3A%2F%2Fcdn.hashnode.com%2Fres%2Fhashnode%2Fimage%2Fupload%2Fv1625295480148%2FlyKj8bpHK.jpeg%3Fw%3D1600%26h%3D840%26fit%3Dcrop%26crop%3Dentropy%26auto%3Dcompress%2Cformat%26format%3Dwebp&w=1920&q=75",
    //     link:"https://codebucks.hashnode.dev/what-is-higher-order-component"
    // },
    // {
    //     id:6,
    //     name:"How to implement Pagination Component in React from scratch",
    //     tags:["react","css"],
    //     date:"5 Jan, 2021",
    //     imgSrc:"https://codebucks.hashnode.dev/_next/image?url=https%3A%2F%2Fcdn.hashnode.com%2Fres%2Fhashnode%2Fimage%2Fupload%2Fv1625240050668%2FGAya9b0XK.png%3Fw%3D1600%26h%3D840%26fit%3Dcrop%26crop%3Dentropy%26auto%3Dcompress%2Cformat%26format%3Dwebp&w=1920&q=75",
    //     link:"https://codebucks.hashnode.dev/pagination-in-react"

    // },
   
    // {
    //     id:7,
    //     name:"What is Redux ? Simply Explained!",
    //     tags:["react","redux","javascript"],
    //     date:"16 May, 2021",
    //     imgSrc:"https://res.cloudinary.com/practicaldev/image/fetch/s--ZY1EK-Eo--/c_imagga_scale,f_auto,fl_progressive,h_420,q_auto,w_1000/https://dev-to-uploads.s3.amazonaws.com/uploads/articles/bcz1u90oq3prr5fga3fs.png",
    //     link:"https://dev.to/codebucks/what-is-redux-simply-explained-2ch7"
    // },
    {
        id:1,
        name:"What to Choose React Native Or Flutter?",
        tags:["react-native","flutter","app"],
        date:"27 Aug, 2021",
        imgSrc:"https://res.cloudinary.com/practicaldev/image/fetch/s--rv4I8UwE--/c_imagga_scale,f_auto,fl_progressive,h_420,q_auto,w_1000/https://dev-to-uploads.s3.amazonaws.com/uploads/articles/0a9h50milhlf1us6mn4a.png",
        link:"https://medium.com/@ktsrivastava29/what-to-choose-react-native-or-flutter-6b51f2b3c94d"
    },
    {
        id:2,
        name:"What to Choose React Native Or Flutter?",
        tags:["react-native","flutter","app"],
        date:"27 Aug, 2021",
        imgSrc:"https://res.cloudinary.com/practicaldev/image/fetch/s--rv4I8UwE--/c_imagga_scale,f_auto,fl_progressive,h_420,q_auto,w_1000/https://dev-to-uploads.s3.amazonaws.com/uploads/articles/0a9h50milhlf1us6mn4a.png",
        link:"https://medium.com/@ktsrivastava29/what-to-choose-react-native-or-flutter-6b51f2b3c94d"
    },
    {
        id:3,
        name:"What to Choose React Native Or Flutter?",
        tags:["react-native","flutter","app"],
        date:"27 Aug, 2021",
        imgSrc:"https://res.cloudinary.com/practicaldev/image/fetch/s--rv4I8UwE--/c_imagga_scale,f_auto,fl_progressive,h_420,q_auto,w_1000/https://dev-to-uploads.s3.amazonaws.com/uploads/articles/0a9h50milhlf1us6mn4a.png",
        link:"https://medium.com/@ktsrivastava29/what-to-choose-react-native-or-flutter-6b51f2b3c94d"
    },
    {
        id:4,
        name:"What to Choose React Native Or Flutter?",
        tags:["react-native","flutter","app"],
        date:"27 Aug, 2021",
        imgSrc:"https://res.cloudinary.com/practicaldev/image/fetch/s--rv4I8UwE--/c_imagga_scale,f_auto,fl_progressive,h_420,q_auto,w_1000/https://dev-to-uploads.s3.amazonaws.com/uploads/articles/0a9h50milhlf1us6mn4a.png",
        link:"https://medium.com/@ktsrivastava29/what-to-choose-react-native-or-flutter-6b51f2b3c94d"
    },
  
] 